import React from 'react'

function MetaContainer({ children }) {
  return (
    <div className="u-flex u-flex-wrap">
      {children}
    </div>
  )
}

export default MetaContainer
